"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoPlayerDealCommand = void 0;
const draw_deck_player_action_1 = require("../../actions/draw-deck-player-action");
class AutoPlayerDealCommand {
    static isCommand(command) {
        return command instanceof AutoPlayerDealCommand;
    }
    executeCommand(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentPlayer = context.playerManager.currentPlayer;
            const drawDeckPlayerAction = new draw_deck_player_action_1.DrawDeckPlayerAction(context.playerManager.board, currentPlayer.playerId);
            drawDeckPlayerAction.execute();
            yield context.dealProcessor.disclosePendingCards(commandHash, existingDeal);
            drawDeckPlayerAction.resolve();
            context.eventQueue.enqueue({
                type: "onDrawDeckPlayer",
                instant,
                payload: {
                    player: currentPlayer.clone(),
                    cardIndex: drawDeckPlayerAction.cardIndex,
                },
            });
        });
    }
}
exports.AutoPlayerDealCommand = AutoPlayerDealCommand;
